import React from "react";
import { motion } from "framer-motion";

import { useTranslation } from "react-i18next";
import BtnPlayStore from "../../components/BtnPlayStore";
import BtnAppStore from "../../components/BtnAppStore";
import Boutton from "../../components/Button";
const Urgences = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut", staggerChildren: 0.2 },
    },
  };
  const staggerContainer = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const zoomRotate = {
    hidden: { scale: 0.8, rotate: -15, opacity: 0 },
    visible: { scale: 1, rotate: 0, opacity: 1, transition: { duration: 1 } },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } },
  };

  // composant (cartes) reutilisable

  const textColor = ["text-white", "text-white", "text-black"];

  const items = [
    {
      icon: "/assets/images/vecteurs/health.svg",
      title: t("UrgencesPage.Cards.Simplicite"),
      description: t("UrgencesPage.Cards.SimpliciteTexte"),
      bgColor: "bg-blue-primary",
      glowEffect: "pulse-glow-blue",
    },
    {
      icon: "/assets/images/vecteurs/secure-svgrepo-com.svg ",
      title: t("UrgencesPage.Cards.Securite"),
      description: t("UrgencesPage.Cards.SecuriteTexte"),
      bgColor: "bg-[#BE0209]",
      glowEffect: "pulse-glow-red",
    },
    {
      icon: "/assets/images/vecteurs/time-success-svgrepo-com.svg",
      title: t("UrgencesPage.Cards.Intervention"),
      description: t("UrgencesPage.Cards.InterventionTexte"),
      bgColor: "bg-[#2AC100]",
      glowEffect: "pulse-glow-green",
    },
  ];

  return (
    <main className="max-w-[1900px] mx-auto">
      {/**  SECTION ONE */}
      <motion.section
        id="landing"
        className="w-full "
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div
          id="container"
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className=" bg-center bg-cover md:relative -z-10 max-w-[1300px] mx-auto "
          style={{
            backgroundImage: "url(/assets/images/urgences/red_background.png)",
          }}
        >
          {/*  */}
          <div
            className="relative hidden md:flex -z-20 md:absolute top-[32%] bottom-0 bg-gradient-to-r from-[#134888] to-[#32E800]  w-full clip-path "
            style={{
              clipPath:
                "polygon( 0% 24.719%,0.127% 24.673%,0.022% 48.883%,0% 54.036%,0% 99.782%,99.928% 99.782%,99.928% 88.129%,99.928% 88.129%,97.7% 88.126%,93.224% 88.123%,87.06% 88.12%,79.771% 88.117%,71.92% 88.114%,64.069% 88.111%,56.781% 88.108%,50.617% 88.107%,46.14% 88.105%,43.913% 88.105%,43.913% 88.105%,41.57% 88.104%,39.227% 88.104%,36.884% 88.104%,34.541% 88.104%,32.198% 88.105%,29.856% 88.106%,27.513% 88.106%,25.17% 88.107%,22.827% 88.109%,20.484% 88.11%,20.484% 88.11%,20.096% 88.094%,19.713% 88.043%,19.334% 87.95%,18.961% 87.812%,18.594% 87.621%,18.234% 87.373%,17.881% 87.062%,17.537% 86.683%,17.201% 86.231%,16.875% 85.699%,16.875% 85.699%,16.659% 85.288%,16.458% 84.854%,16.271% 84.396%,16.1% 83.913%,15.943% 83.405%,15.802% 82.873%,15.677% 82.314%,15.567% 81.73%,15.473% 81.12%,15.394% 80.484%,15.394% 80.484%,15.247% 79.124%,15.098% 77.765%,14.949% 76.406%,14.8% 75.047%,14.65% 73.689%,14.5% 72.331%,14.351% 70.972%,14.201% 69.614%,14.052% 68.256%,13.903% 66.897%,13.903% 66.897%,13.892% 66.759%,13.881% 66.621%,13.87% 66.482%,13.86% 66.343%,13.851% 66.203%,13.842% 66.064%,13.834% 65.924%,13.826% 65.783%,13.818% 65.643%,13.812% 65.502%,12.895% 57.693%,12.855% 57.349%,12.745% 56.416%,11.985% 49.938%,11.944% 49.594%,11.905% 49.263%,11.882% 49.056%,10.008% 33.097%,10.008% 33.097%,9.984% 33.103%,9.96% 33.108%,9.936% 33.113%,9.912% 33.119%,9.888% 33.124%,9.864% 33.129%,9.84% 33.135%,9.816% 33.14%,9.792% 33.145%,9.768% 33.151%,10.005% 33.079%,9.719% 30.633%,9.661% 30.141%,9.466% 28.486%,9.067% 25.077%,8.749% 22.378%,8.445% 19.785%,8.445% 19.785%,8.393% 19.357%,8.34% 18.93%,8.287% 18.502%,8.234% 18.074%,8.181% 17.647%,8.127% 17.219%,8.072% 16.792%,8.017% 16.365%,7.961% 15.938%,7.905% 15.512%,7.905% 15.512%,7.797% 14.687%,7.691% 13.86%,7.585% 13.032%,7.478% 12.205%,7.369% 11.379%,7.257% 10.557%,7.141% 9.739%,7.018% 8.927%,6.889% 8.122%,6.752% 7.326%,6.752% 7.326%,6.471% 5.939%,6.148% 4.692%,5.783% 3.586%,5.376% 2.624%,4.928% 1.808%,4.437% 1.141%,3.904% 0.625%,3.329% 0.261%,2.712% 0.053%,2.053% 0.003%,2.053% 0.003%,1.847% 0.011%,1.642% 0.017%,1.437% 0.022%,1.232% 0.025%,1.026% 0.028%,0.821% 0.03%,0.616% 0.033%,0.411% 0.035%,0.205% 0.037%,0% 0.04% )",
            }}
          >
            <div className="text-white  lg:text-[20px] font-bold absolute bottom-2 hidden md:flex pl-[10%] lg:pl-[8%] xl:pl-[15%] z-50 ">
              <p className="">
                {t("UrgencesPage.consultationImmediate.fiabilite")}
              </p>
              <p className="px-12 lg:px-20 xl:px-28">
                
                {t("UrgencesPage.consultationImmediate.rapidite")}
              </p>
              <p className="">
                
                {t("UrgencesPage.consultationImmediate.securite")}
              </p>
              
            </div>
          </div>
          {/*  */}

          <div className=" sm:overflow-hidden pt-28  pb-8 px-6 md:pl-24 sm:pr-0 sm:pb-0 text-base sm:flex md:pt-12 lg:pt-20 ">
            <div className=" sm:w-1/2 sm:pb-8 md:my-24  ">
              <div className="  md:ml-[6%] lg:ml-[14%] xl:ml-[16%]">
                <p className="font-extrabold text-[17px] leading-[22px] md:text-[20px] md:leading-[26px]  xl:text-[26px] xl:leading-[32px]">
                  {t("UrgencesPage.consultationImmediate.besoin")}
                  <span className="text-[#FF0009]">
                    {t("UrgencesPage.consultationImmediate.immediat")}
                  </span>

                  <br />
                  {t("UrgencesPage.consultationImmediate.nousSommes")}
                </p>

                <p className="my-4 xl:text-[19px]">
                  {t("UrgencesPage.consultationImmediate.texte")}
                </p>

                <div className="flex flex-col items-center sm:items-start md:ml-5 ">
                  <p className="font-semibold italic pb-3 xl:text-[18px] lg:pb-4">
                    {t("UrgencesPage.consultationImmediate.besoinAide")}
                  </p>
                  <Boutton
                  className="bg-[#FF0009] text-white"
                    label={t("UrgencesPage.consultationImmediate.telecharger")}
                    icon={<img
                      src="/assets/images/vecteurs/download.svg"
                      alt="download"
                      className="w-6"
                    /> }
                  />
                </div>
              </div>
            </div>
            <div className="hidden sm:flex w-1/2 items-end md:w-2/3 xl:w-1/2">
              <div
                className=" w-full bg-cover bg-no-repeat bg-left-bottom h-[240px] sm:h-[280px] md:h-[380px] "
                style={{
                  backgroundImage: "url(/assets/images/urgences/hero.png",
                }}
              >
                {/* <img
                src="/assets/images/urgences/hero.png"
                alt="ambulace"
                className="object-cover object-left-bottom h-[240px] sm:h-[280px] md:h-[380px] "
              /> */}
              </div>
            </div>
          </div>
        </motion.div>
      </motion.section>

      {/**  SECTION TWO */}
      <motion.section
        id="landing"
        className="w-full my-9 xl:my-14"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div
          id="container"
          initial="hidden"
          animate="visible"
          variants={zoomRotate}
          className="md:grid md:grid-cols-2 lg:grid-cols-3 lg:gap-0 max-w-[1300px] mx-auto "
        >
          {items.map((items, index) => (
            <div key={index} className="h-full p-4 md:p-6 lg:p-4">
              <div
                className={`h-full ${items.bgColor}  w-[97%] sm:w-[70%] md:w-[100%]  rounded-2xl shadow-md shadow-gray-400 flex flex-col px-[10px] lg:px-[4px] mx-auto justify-center   ${items.glowEffect} `}
                style={{ transform: "translate3d(0, 0, 0)" }}
              >
                <div className="max-[370px]:h-[215px] h-[205px]  sm:h-[200px] lg:h-[230px] pt-2 sm:pt-5 md:pt-2 sm:px-2">
                  <div className=" flex items-center ">
                    <img
                      src={items.icon}
                      alt={items.title}
                      className="w-[50px] h-[50px] object-contain mt-2"
                    />

                    <p className={` text-[18px] font-bold pl-2 ${textColor[index]} `}>
                      {items.title}
                    </p>
                  </div>
                  <p
                    className={` ${textColor[index]} text-[16px] font-medium px-4 ml-12 `}
                  >
                    {items.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </motion.section>

      {/**  SECTION THREE */}
      <motion.section
        id="landing"
        className="w-full mt-8 mb-5 bg-slate-100 shadow-2xl  border-slate-100"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div
          id="container"
          initial="hidden"
          animate="visible"
          variants={itemVariants}
          className="max-w-[1300px] mx-auto "
        >
          <div className=" mx-5 justify-center sm:flex md:gap-3 ">
            <div className="flex flex-col items-center py-6 sm:w-1/2 sm:items-start md:justify-center ">
              <p className="text-[26px] leading-[28px] md:text-[28px] md:leading-[34px] font-bold md:font-extrabold text-center sm:text-left sm:text-[30px] text-[#134888] px-2 sm:px-0 xl:text-[40px] xl:leading-[40px] ">
                {t("UrgencesPage.reservezUne")}
              </p>
              <p className="text-[17px] md:text-[19px] max-sm:italic  leading-[21px] md:leading-[24px] mt-3 mb-5 md:my-7 md:font-medium text-left xl:text-[22px] xl:leading-[28px] 2xl:my-14 ">
                {t("UrgencesPage.reservezUneTexte")}
              </p>
              <div className="flex  gap-4 md:gap-3 ">
                <BtnAppStore />

                <BtnPlayStore />
              </div>
            </div>
            <div className="hidden sm:flex ">
              <img
                src="/assets/images/urgences/phone ambulance.png"
                alt="Phone ambulance"
                className="w-[320px] md:w-[400px] lg:w-[480px] xl:w-[580px] object-cover "
              />
            </div>
          </div>
        </motion.div>
      </motion.section>
    </main>
  );
};

export default Urgences;
